/** Task colours, shared by the calendar and the dashboard so the two never drift. */
export const MEETING_COLOR = '#6366f1'
export const REMINDER_COLOR = '#f59e0b'

export function taskColor(type: string): string {
  return type === 'meeting' ? MEETING_COLOR : REMINDER_COLOR
}

/** "12 Aug 2026, 09:30" — the calendar's own long form, empty for null. */
export function formatTaskDateTime(iso: string | null): string {
  if (!iso) return ''
  return new Date(iso).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
}
